import { gql } from "@apollo/client";

export const GET_TOP_PRODUCTS = gql`
  query getTopProducts {
    products(filter: { top_product: { eq: "1" } }) {
      total_count
      items {
        id
        attribute_set_id
        name
        unit_text
        url_key
        flag_text
        stock_status
        type_id
        sku
        uid
        image {
          url
          label
        }
        categories {
          url_key
          name
        }
        small_image {
          url
          label
        }
        simplebundle
        __typename
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
          maximum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        ... on BundleProduct {
          items {
            option_id
            title
            sku
            type
            required
            position
            options {
              price
              quantity
              product {
                uid
                id
                name
                unit_text
                small_image {
                  url
                  label
                }
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                    final_price {
                      value
                      currency
                    }
                    discount {
                      amount_off
                      percent_off
                    }
                  }
                  maximum_price {
                    regular_price {
                      value
                      currency
                    }
                    final_price {
                      value
                      currency
                    }
                    discount {
                      amount_off
                      percent_off
                    }
                  }
                }
                __typename
              }
            }
          }
        }
        ... on ConfigurableProduct {
          variants {
            product {
              id
              name
              unit_text
              small_image {
                url
                label
              }
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
                maximum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default {
  getTopProducts: GET_TOP_PRODUCTS,
};
